<template>
    <div class="UserMenu">
        <span v-if="token && $utils.isNotMobile()" class="pl-3 pr-1" style="color: #fff">
            {{ profile.name }}
        </span>
        <v-menu v-if="token" :close-on-content-click=true :nudge-width="200" offset-y>
            <template v-slot:activator="{ on }">
                <v-btn dark icon v-on="on">
                    <v-icon>person</v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-list>
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <v-icon size="30">person</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title class="username">{{ profile.name }}</v-list-tile-title>
                            <v-list-tile-sub-title>
                                <a :href="openid_url" target="_blank" class="user-link">
                                    {{ profile.email }}
                                </a>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <template v-if="notProduction">
                    <v-divider></v-divider>
                    <table class="my-2 mx-1">
                        <tr>
                            <td>Env</td>
                            <td>{{appEnv}}</td>
                        </tr>
                        <tr>
                            <td>Version</td>
                            <td>{{appVersion}}</td>
                        </tr>
                        <tr>
                            <td>Build</td>
                            <td>{{buildTime}}</td>
                        </tr>
                        <tr>
                            <td>Token Expire</td>
                            <td>{{tokenExpire}}</td>
                        </tr>
                        <tr>
                            <td style="vertical-align: top">Roles</td>
                            <td>
                                <div v-for="role in profile.roles" :key="role">
                                    {{role}}
                                </div>
                            </td>
                        </tr>
                    </table>
                </template>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="signOut">{{$t('signOut')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import $utils from '@/utils/utils'
import moment from 'moment'

export default {
    name: 'UserMenu',
    data () {
        return {
            openid_url: '',
            appEnv: process.env.NODE_ENV,
            buildTime: moment(Number(process.env.VUE_APP_BUILD_TIME)).format('HH:mm:ss DD-MM-YYYY'),
            $utils: this.$utils,
            notProduction: process.env.NODE_ENV !== this.$const.env.PRO
        }
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile,
            token: state => state.user.token,
            appVersion: state => state.version,
            buildVersion: state => state.buildVersion,
            tokenExpire: state => {
                if (state.user.token) {
                    return moment($utils.parseJwt(state.user.token).exp * 1000).format('HH:mm:ss')
                }
                return 0
            }
        })
    },
    async mounted () {
        this.openid_url = process.env.VUE_APP_PROFILE_END_POINT
    },
    methods: {
        signOut () {
            this.$store.dispatch(this.$actionTypes.user.SIGN_OUT)
        }
    }
}
</script>
<style scoped>
    .username {
        font-weight: bold;
    }

    .user-link {
        color: #649FDF;
        text-decoration: none;
    }

    table tr td:first-child {
        font-weight: bold;
        padding-right: 10px;
    }
</style>
